import moment from "moment"

// format yyyy-mm-dd
const formatDate = (date, timeZoneMode = "local") => {
  let d = new Date(date),
    month,
    day,
    year
  if (timeZoneMode === "global") {
    month = "" + (d.getUTCMonth() + 1)
    day = "" + d.getUTCDate()
    year = d.getUTCFullYear()
  } else {
    month = "" + (d.getMonth() + 1)
    day = "" + d.getDate()
    year = d.getFullYear()
  }

  if (month.length < 2) month = "0" + month
  if (day.length < 2) day = "0" + day

  return [year, month, day].join("-")
}

const timestampToDate = (unix, format, local = "local") => {
  return local == "local"
    ? moment(unix)
      .locale("th")
      .add(543, "year")
      .format(format)
    : moment(unix)
      .locale("th")
      .format(format)
}

const timestampToGraphDate = (unix, format) => {
  return moment(unix)
    .locale("th")
    .format(format)
}

const calPercentChange = (firstPrice, lastPrice, setDecimal = 2) => {
  return firstPrice
    ? ((parseFloat(lastPrice) / parseFloat(firstPrice)) * 100 - 100).toFixed(
      setDecimal
    )
    : "0"
}

const convertPeriodToMs = periods => {
  let num = periods.replace(/\D/g, "")
  let str = periods.replace(/\d/g, "")
  switch (str) {
    case "M":
      return Math.floor(num * 60 * 1000)
    case "H":
      return Math.floor(num * 60 * 60 * 1000)
    case "D":
      return Math.floor(num * 24 * 60 * 60 * 1000)
  }
}

const findPreviousDate = periods => {
  let num = periods.replace(/\D/g, "")
  let str = periods.replace(/\d/g, "")
  switch (str) {
    case "m":
      return moment()
        .subtract(num, "minute")
        .format("YYYY-MM-DD")
    case "Y":
      return moment()
        .subtract(num, "years")
        .format("YYYY-MM-DD")
    case "M":
      return moment()
        .subtract(num, "months")
        .format("YYYY-MM-DD")
    case "W":
      return moment()
        .subtract(num, "weeks")
        .format("YYYY-MM-DD")
    case "D":
      return moment()
        .subtract(num, "days")
        .format("YYYY-MM-DD")
    case "YTD":
      var thisYear = new Date().getFullYear()
      var start = new Date("1/1/" + thisYear)
      return moment(start.valueOf()).format("YYYY-MM-DD")
    case 'Max':
      return "1990-01-01"
    default:
      return moment()
        .subtract(1, "days")
        .format("YYYY-MM-DD")
  }
}

const findNextTime = (periods, globalConfig) => {
  let interval = globalConfig.filter(item => item.period == periods).map(item => item.interval).toString()
  let intervalSecond = ["1m", "5m", "15m", "1h"]
  let date, time, nextTime
  if (intervalSecond.includes(periods)) {
    date = new Date()
    time = date.getSeconds()
    nextTime = time + parseInt(interval)
    date.setSeconds(nextTime)
  } else {
    date = new Date()
    time = date.getMinutes()
    nextTime = time + parseInt(interval)
    date.setMinutes(nextTime)
    date.setSeconds(0)
  }
  return date
}

const convertHex = (hex, opacity) => {
  hex = hex.replace('#', '')
  let r = parseInt(hex.substring(0, 2), 16)
  let g = parseInt(hex.substring(2, 4), 16)
  let b = parseInt(hex.substring(4, 6), 16)

  return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
}

const formatCurrency = (price, currency, digit = 2) => {
  let toNumber = parseFloat(price)
    .toLocaleString("th", {
      minimumFractionDigits: digit,
      maximumFractionDigits: digit
    })
    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  switch (currency) {
    case 'THB':
      return `${toNumber} ฿`
    case 'USD':
      return `$ ${toNumber}`
    case 'NONE':
      return toNumber
    default:
      return `require currency type`
  }
}

export {
  formatCurrency,
  formatDate,
  timestampToDate,
  timestampToGraphDate,
  calPercentChange,
  convertPeriodToMs,
  findPreviousDate,
  findNextTime,
  convertHex
}
